import "../PurchasingUi.css";
import { getUnitName } from "../utils/unitNames";
import "./StockOperations.css";

const NUMBER_FORMATTER = new Intl.NumberFormat("es-ES", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const TRANSFER_QUANTITY_FORMATTER = new Intl.NumberFormat("es-ES", { maximumFractionDigits: 12 });

export function formatStockTransferQuantity(quantity, unit, languageId) {
  return [TRANSFER_QUANTITY_FORMATTER.format(Number(quantity)), getUnitName(unit, languageId)].filter(Boolean).join(" ");
}

const CURRENCY_FORMATTER = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function normalizeStockStatus(value) {
  const status = String(value || "").trim().toLowerCase();
  if (status === "fulfilled") return "dispatched";
  if (status === "partially dispatched" || status === "partial") return "partially_dispatched";
  return status;
}

export function getStockRequisitionStatusMeta(value) {
  const status = normalizeStockStatus(value);

  if (status === "draft") return { label: "Draft", tone: "draft", key: status };
  if (status === "returned") return { label: "Returned", tone: "partial", key: status };
  if (status === "rejected") return { label: "Rejected", tone: "cancelled", key: status };
  if (status === "confirmed") return { label: "Confirmed", tone: "confirmed", key: status };
  if (status === "approved") return { label: "Approved", tone: "approved", key: status };
  if (status === "dispatched") return { label: "Dispatched", tone: "dispatched", key: status };
  if (status === "partially_dispatched" || status === "partially dispatched") {
    return { label: "Partially Dispatched", tone: "partial", key: status };
  }
  if (status === "cancelled") return { label: "Cancelled", tone: "cancelled", key: status };

  return {
    label: status ? status.replace(/_/g, " ") : "Unknown",
    tone: "draft",
    key: status,
  };
}

export function formatStockOpsDate(value) {
  if (!value) return "-";
  try {
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(value));
  } catch (error) {
    return "-";
  }
}

export function formatStockOpsNumber(value) {
  return NUMBER_FORMATTER.format(Number(value || 0));
}

export function formatStockOpsCurrency(value) {
  return CURRENCY_FORMATTER.format(Number(value || 0));
}

export function truncateStockOpsText(value, maxLength = 65) {
  const text = String(value || "-");
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}
